export { getCountryByIp };
import { getConfig } from '@chegg-web-tools/config-plugin';

async function getCountryByIp(ip: string) {
  const geoLocationUrl = getConfig('geoLocation');

  const GEO_LOCATION_QUERY = `
{
  getGeolocation(ip:"${ip}"){
    countryCode
  }
}
`;
  try {
    const res = await fetch(geoLocationUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query: GEO_LOCATION_QUERY }),
    });
    const { data } = await res.json();
    return data.getGeolocation.countryCode;
  } catch (error) {
    console.error('invalid ip usage with setip url query');
    return '';
  }
}
